import React, { useMemo } from 'react'
import { makeStyles, ImageList, ImageListItem } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import useRolePermissions from 'hooks/useRolePermissions'
import DashboardCard from './DashboardCard'
import { permittedDashboards } from './supportDashboards'

const useSupportDashboardStyles = makeStyles({
  container: {
    maxWidth: '1200px',
    width: '80%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 70,
    margin: '0 auto'
  },
  title: {
    fontSize: 30,
    fontWeight: 'bold',
    marginTop: 90,
    marginBottom: 30
  },
  cardContainer: {
    overflow: 'initial'
  }
})

const SupportDashboardPicker = ({ id, containerClassName }) => {
  const classes = useSupportDashboardStyles()
  const { permissions } = useRolePermissions()
  const { t } = useTranslation()

  const availableDashboards = useMemo(
    () => permittedDashboards(permissions).map(({ route, labelKey }) => ({ route, label: t(labelKey) })),
    [permissions, t]
  )

  return (
    <div id={id} className={[classes.container, containerClassName].join(' ')}>
      <ImageList cols={3} rowHeight="auto">
        {availableDashboards.map(({ label, route }) => (
          <ImageListItem key={route} classes={{ item: classes.cardContainer }}>
            <DashboardCard label={label} route={route} />
          </ImageListItem>
        ))}
      </ImageList>
    </div>
  )
}

export default SupportDashboardPicker
